module.exports = __webpack_public_path__ + "img/green-icon(3).103a7149.png";